<template>
  <div class="mono-edit" :style="{ height: resolvedHeight }">
    <MonacoEditor
      :value="modelValue"
      :language="language"
      :theme="theme"
      :options="editorOptions"
      class="mono-edit__editor"
      @update:value="onUpdate"
    />
  </div>
</template>

<script>
import MonacoEditor from 'monaco-editor-vue3'

export default {
  name: 'MonoEdit',
  components: { MonacoEditor },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    /** 数字为 px，字符串支持 vh、px 等 CSS 长度 */
    height: {
      type: [String, Number],
      default: 'min(72vh, 720px)'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'vs-light'
    },
    /** markdown | json | yaml 等 Monaco 语言 id */
    language: {
      type: String,
      default: 'markdown'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    resolvedHeight() {
      return typeof this.height === 'number' ? `${this.height}px` : this.height
    },
    editorOptions() {
      return {
        automaticLayout: true,
        minimap: { enabled: true },
        scrollBeyondLastLine: false,
        fontSize: 14,
        lineNumbers: 'on',
        wordWrap: 'on',
        roundedSelection: false,
        readOnly: this.readOnly,
        tabSize: 2
      }
    }
  },
  methods: {
    onUpdate(val) {
      this.$emit('update:modelValue', val ?? '')
    }
  }
}
</script>

<style scoped>
.mono-edit {
  width: 100%;
  border: 1px solid var(--el-border-color);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.mono-edit__editor {
  height: 100%;
  width: 100%;
  position: absolute;
  inset: 0;
}

.mono-edit :deep(.monaco-editor-vue3),
.mono-edit :deep(.monaco-editor),
.mono-edit :deep(.monaco-editor-background) {
  width: 100% !important;
  max-width: 100%;
}

.mono-edit :deep(.monaco-editor) {
  position: absolute;
  inset: 0;
}
</style>
